exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".social-sidebar {\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  top: 50%;\n  -webkit-transform: translateY(-30%);\n  -ms-transform: translateY(-30%);\n  transform: translateY(-30%); }\n\n.social-btn {\n  padding: 1px 1px 1px 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/SocialSidebar/socialSidebar.scss
// module id = 347
// module chunks = 0